import { SEND_FORGOT_PASSWORD_EMAIL } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';

export default {
  name: 'ResetPasswordSent',
  components: {
    OnboardingIndex
  },
  mixins: [alert_mixin],
  data: () => ({
    email: sessionStorage.getItem('reset_email') || '',
    countdown: 15,
    is_resend_disabled: true,
    timer: null,
    base_time: 15
  }),
  mounted() {
    this.start_timer();
  },
  beforeUnmount() {
    this.clear_timer();
  },
  methods: {
    start_timer() {
      this.is_resend_disabled = true;
      this.clear_timer();
      
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.clear_timer();
          this.is_resend_disabled = false;
        }
      }, 1000);
    },
    clear_timer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    reset_timer() {
      this.is_resend_disabled = true;
      this.clear_timer();
      this.base_time += 5; // Add 5 seconds penalty
      this.countdown = this.base_time;
      this.start_timer();
    },
    async resend_email() {
      if (this.is_resend_disabled) return;

      this.is_resend_disabled = true;
      
      try {
        const response = await axios.post(SEND_FORGOT_PASSWORD_EMAIL, { 
          email: this.email 
        });

        // Parse the stringified JSON response
        const response_data = JSON.parse(response.data);

        if (response_data.status === 'success') {
          this.show_success("Resent reset link to your email");
          this.reset_timer();
        } else {
          this.is_resend_disabled = false;
          this.show_error(response_data.message || 'Failed to resend email');
        }
      } catch (error) {
        this.is_resend_disabled = false;
        this.show_error('Failed to resend email. Please try again.');
      }
    }
  }
};
